'use client';

import { css, cx } from '@onbeam/business-styled-system/css';
import { flex, text, vstack } from '@onbeam/business-styled-system/patterns';
import { Button } from '@onbeam/business-ui';
import { Popover } from '@/components/shared/Popover';
import { Accordion } from '@/components/shared/Accordion';
import { AccordionGroup } from '@/components/shared/AccordionGroup';
import { MenuDivider, MenuGroup, MenuItem } from '@/components/shared/Menu';
import { getStartedButtonData } from './GetStartedButton.utils';
import { isMenuItem } from '@/components/shared/Menu/Menu.types';

export const GetStartedButton = () => (
  <Popover
    trigger={<Button>Get involved</Button>}
    align="end"
    sideOffset={0}
    className={cx(
      'dark',
      vstack({
        bg: 'mono.primaryFg',
        color: 'mono.primaryBg',
        w: '[14.125rem]',
        mt: '[calc(var(--radix-popover-trigger-height) * -1)]',
      }),
    )}
  >
    <AccordionGroup type="multiple">
      {getStartedButtonData.map(({ icon: Icon, ...item }) => (
        <Accordion
          key={item.value}
          value={item.value}
          title={
            <div className={flex({ gap: '2', align: 'center' })}>
              <Icon height={24} width={24} />
              <span
                className={text({
                  style: 'body-sm',
                })}
              >
                {item.label}
              </span>
            </div>
          }
        >
          {item.items.map((subItem, index) =>
            isMenuItem(subItem) ? (
              <MenuItem
                key={subItem.href}
                href={subItem.href}
                isExternal={subItem.isExternal}
                className={css({ pl: '8' })}
              >
                {subItem.label}
              </MenuItem>
            ) : (
              <>
                <MenuGroup
                  group={subItem}
                  key={subItem.title}
                  itemClassName={css({ pl: '8' })}
                  titleClassName={css({ pl: '8' })}
                />
                {index !== item.items.length - 1 && (
                  <MenuDivider className={css({ pl: '8' })} />
                )}
              </>
            ),
          )}
        </Accordion>
      ))}
    </AccordionGroup>
  </Popover>
);
